import whenWindowLoaded from '@netc/when-window-loaded';
import { useEffect, useState } from 'react';

const useWhenWindowLoaded = (): boolean => {
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    whenWindowLoaded().then(() => setLoaded(true));
  }, []);

  return loaded;
};

export default useWhenWindowLoaded;
